<template>
  <div class="page_paymentDtl">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/payment',query:{
            activeName:'待发薪'
          } }">待发薪</el-breadcrumb-item>
          <el-breadcrumb-item>打款</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">

        <div class="basicInfo flex" v-if="baseInfo != {} && baseInfo != null">
          <div class="infoItem">发薪项目: {{ baseInfo.ProjectName }}</div>
          <div class="infoItem">归属月: {{ baseInfo.AttrMonth }}</div>
          <div class="infoItem" style="min-width:330px">发薪实体: {{ baseInfo.PayrollCompany }}</div>
          <div class="infoItem" style="min-width:330px">商务合同主体: {{ baseInfo.Subject }}</div>
          <div class="infoItem">客户企业: {{ baseInfo.CustomerName }}</div>
          <div class="infoItem">发放途径: {{ baseInfo.PayrollChannel }}</div>
          <div class="infoItem">导入表: <span v-if="baseInfo.PayScaleRul" @click="down(baseInfo.PayScaleRul, headPath)" class="down cp">下载</span></div>
          <div class="infoItem">客户原表: <span v-if="baseInfo.CustomerOriginalTableRul" @click="down(baseInfo.CustomerOriginalTableRul, docHeadPath)" class="down cp">下载</span></div>
          <div class="infoItem">应发总金额: {{ baseInfo.TotalResponse }}</div>
          <div class="infoItem">实发总金额: {{ baseInfo.GrandTotal }}</div>
          <div class="infoItem">申请备注: {{ baseInfo.ApplyforRemark }}</div>
          <!-- <div class="infoItem">已打款人数: {{baseInfo.AttrMonth}}</div>
          <div class="infoItem">打款失败金额: {{baseInfo.AttrMonth}}</div>
          <div class="infoItem">待打款金额: {{baseInfo.AttrMonth}}</div> -->
        </div>
        <!-- <el-form :inline="true">
          <el-form-item label="向商务主体转款" label-width="115px">
            <el-select v-model="dzAcc" value-key="Account" placeholder="选择垫支公司/银行账户" size="small" clearable filterable style="width:300px" @change="changeDz">
              <el-option v-for="(item, index) in allAccount" :key="index" :label="item.CompanyName + ' / ' + item.Account" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="垫支金额" label-width="90px">
            <div class="dzItem">{{ baseInfo.ApplyDeposit }}</div>
          </el-form-item>
        </el-form> -->
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="cbsPayment">提交CBS打款</el-button>
          <el-button type="warning" size="small" @click="cbsAllPayment">全部提交CBS打款</el-button>
          <el-popconfirm :title="'本次勾选发薪共' + multipleSelection.length + '条数据，确认打款成功？'" style="margin-left: 10px;" @confirm="handel('success')">
            <el-button type="success" size="small" slot="reference">登记手工打款成功</el-button>
          </el-popconfirm>

          <el-popconfirm :title="'本次勾选打款失败共' + multipleSelection.length + '条数据，确认打款失败？'" style="margin: 0 10px;" @confirm="handel('fail')">
            <el-button type="danger" size="small" slot="reference">登记手工打款失败</el-button>
          </el-popconfirm>
          <el-button type="primary" size="small" @click="exportList">导出</el-button>

          <el-select v-model="listQuery.PayrollCompany" placeholder="选择发薪公司" size="small" style="width: 180px;margin:0 10px" clearable filterable>
            <el-option v-for="(item, index) in legList" :key="index" :value="item.PayrollCompany"></el-option>
          </el-select>
          <el-button type="success" size="small" @click="getApplicationPayrollDetail">筛选</el-button>
          <el-button type="primary" size="small" @click="goback">返回</el-button>
          <!-- <el-button type="primary" size="small">导出全部</el-button> -->
        </div>
        <div style="width:1031px">
          <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:1031px" @selection-change="handleSelectionChange">
            <!-- <el-table-column type="selection" width="40" :selectable="selectEnable">
            </el-table-column> -->
            <el-table-column type="selection" width="40">
            </el-table-column>
            <el-table-column prop="Sort" label="序号" width="50" align="center">
              <template slot-scope="scope">
                {{ (listQuery.pageNum - 1) * Number(listQuery.pageSize) + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="EmployeeName" label="员工姓名" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="IssuedThisMonth" label="金额" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="BankAccount" label="银行账号" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="DepositBank" label="开户行" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ProcessState" label="打款状态" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PayrollCompany" label="发薪公司" width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="Remark1" label="备注" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="UpdataTime" label="更新时间" width="150" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.UpdataTime ? row.UpdataTime.replace('T', ' ') : '' }}</template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
          </div>
        </div>

      </div>
    </div>

    <el-dialog width="500px" title="CBS打款成功" :visible.sync="innerVisibleRes">
      <div class="payResult flex">
        <div>打款成功人数： {{ successData.length }}</div>
        <div class="payAmount">打款成功金额： {{ PayrollSum }}</div>
      </div>
      <div class="wrapperTable">
        <el-table :data="successData" border class="doc_table" style="width:411px">
          <el-table-column prop="Sort" label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{ (listQuery.pageNum - 1) * Number(listQuery.pageSize) + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="EmployeeName" label="姓名" width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IssuedThisMonth" label="金额" width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="innerVisibleRes = false">确
          定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="700px" title="选择发薪子公司银行账户" :visible.sync="innerVisibleCA">
      <div class="salaryPayingCompanyBox" v-if="bankList.length > 0">
        <div class="salaryPayingCompanyItem" v-for="(item, index) in bankList" :key="index">
          <div class="salaryPayingCompany">发薪公司：{{ item.CompanyName }}</div>
          <div style="margin-bottom: 10px;">
            <el-radio-group v-model="item.RpaAccount" @input="(val)=> { changePayType(val, item) }">
              <el-radio label="0">CBS银行账户</el-radio>
              <el-radio label="1">杰小金账户</el-radio>
            </el-radio-group>
          </div>
          <div class="salaryPayingCompany_radio" v-if="item.RpaAccount==0">
            <!-- <el-radio-group v-model="item.payAccount" > -->
            <el-radio :label="bank.Account" v-for="bank in item.AccountList" :key="bank.Account" style="margin-bottom: 10px;" v-model="item.payAccount" @input="(val) => { inputChange(val, item, bank.OpeningBank) }">开户行：{{ bank.OpeningBank }} 帐号：{{ bank.Account}}</el-radio>
            <!-- </el-radio-group> -->
          </div>
          <div class="salaryPayingCompany_radio" v-if="item.RpaAccount==1">
            <!-- <el-radio-group v-model="item.payAccount" > -->
            <el-radio :label="bank.Account" v-for="bank in item.JXJList" :key="bank.Account" style="margin-bottom: 10px;" v-model="item.payAccount" @input="(val) => { inputChange(val, item, bank.OpeningBank) }">开户行：{{ bank.OpeningBank }} 帐号：{{ bank.Account}}</el-radio>
            <!-- </el-radio-group> -->
          </div>
        </div>
      </div>
      <div v-else class="noAccountTips">暂无发薪子公司CBS银行账户</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisibleCA = false" size="small">取 消</el-button>
        <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="beforePay">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="700px" title="提交内部转款" :visible.sync="showInnerPay">
      <div class="salaryPayingCompanyBox" v-if="showInnerPay">
        <div class="salaryPayingCompanyItem">
          <div class="salaryPayingCompany">付款方：{{ baseInfo.Subject }}</div>
          <div class="salaryPayingCompany_radio">
            <el-radio-group v-model="MainpayAccount">
              <el-radio :label="bank.Account" v-for="bank in BankAccount" :key="bank.Account" style="margin-bottom: 10px;" v-if="bank.IsCbs">开户行：{{ bank.OpeningBank }} 帐号：{{ bank.Account
                }}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="salaryPayingCompanyItem" v-if="baseInfo.ApplyDeposit > 0 && ApplyDepositAccount">
          <div class="salaryPayingCompany">付款方（垫支）：{{ dzCompany }}</div>
          <div class="salaryPayingCompany_radio">
            <el-radio-group v-model="ApplyDepositAccount">
              <el-radio :label="ApplyDepositAccount" style="margin-bottom: 10px;">开户行：{{ dzOpenBank }} 帐号：{{
          ApplyDepositAccount }}</el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="salaryPayingCompanyItem" v-for="(item, index) in payAccount2" :key="index">
          <div class="flex sb">
            <div class="salaryPayingCompany">收款方：{{ item.CompanyName }}</div>
            <div class="salaryPayingCompany" style="margin-right:30px"> 金额：￥{{ item.CompanyPayrollSum }}</div>
          </div>
          <div class="salaryPayingCompany_radio flex">
            <div>开户行：{{ item.payOpenBnak }}</div>
            <div>账号：{{ item.Account }}</div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showInnerPay = false" size="small">取 消</el-button>
        <!-- <el-button type="warning" @click="confirmPay" size="small">跳 过</el-button> -->
        <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="confirmInnerPay">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="系统风控提醒" :visible.sync="showSysTips" width="815px" :show-close="false">
      <div class="payTips2">本项目系统已存在相同提交月份+相同卡号+相同金额或相同归属月份+相同卡号+相同金的发薪数据，请确认。</div>
      <el-table :data="sysTipsData" class="doc_table" max-height="500px" style="width:100%;margin-bottom: 6px;" :loading="sysLoading">
        <el-table-column prop="updataTime" label="发生时间" min-width="160" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="employeeName" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="bankAccount" label="卡号" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="issuedThisMonth" label="金额" min-width="140" :show-overflow-tooltip="true" align="center">
          <template slot-scope={row}>{{row.issuedThisMonth ? '￥' + row.issuedThisMonth : ''}}</template>
        </el-table-column>
        <el-table-column prop="attrMonth" label="归属月" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="processState" label="发薪状态" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()" size="small">取 消</el-button>
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="showSysSms = true">确认，继续</el-button>
      </span>
    </el-dialog>

    <el-dialog title="获取验证码" :visible.sync="showSysSms" width="500px" :show-close="false">
      <el-form>
        <el-form-item label="请输入验证码" label-width="100px">
          <el-input v-model="VerifCode" style="width:120px" size="small"></el-input>
          <el-button type="primary" size="small" style="margin-left:10px" :disabled="countdown>0" @click="sendSms">{{countdown == 0 ? '发送短信' : '重新发送（' + countdown + '）'}}</el-button>
        </el-form-item>
      </el-form>
      <div>注:验证码将发放到您在数字化系统登记的手机号</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSysSms = false" size="small">取 消</el-button>
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="checkSms">确认发放</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="showBSTips" :show-close="false" width="500px">
      <div style="font-size: 16px;">
        报销款应先收到发票，再打款。请与会计确认，是否收到报销发票？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="goback">未收到</el-button>
        <el-button type="success" v-preventReClick style="margin-left:10px;" size="small" @click="showBSTips = false">已收到</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="showLWtips" :show-close="false" width="500px">
      <div style="font-size: 16px;">
        劳务报酬应先提交发票，再打款。劳务报酬发票是否提交给会计？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="goback">未收到</el-button>
        <el-button type="success" v-preventReClick style="margin-left:10px;" size="small" @click="showLWtips = false">已收到</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          name: '',
          id: '',
          ProcessState: '待发薪',
          PayrollCompany: '', //发薪公司
          pageNum: 1,
          pageSize: 10,
        },
        showDropScreen: -1,
        tableData: [],
        formData: {
          name: ''
        },
        rules: {
          name: {
            required: true,
            message: '请输入',
            trigger: 'blur'
          },
        },
        showSysSms: false,
        baseInfo: {},
        roletype: localStorage.loginRoletype,
        multipleSelection: [],
        totalCount: 0,
        Num: 6,
        activeName: '4',
        loading: false,
        showPayment: false, //打款弹窗
        innerVisibleCA: false, //提交CBS打款弹窗
        innerVisibleRes: false, //打款结果弹窗
        radio: '1',
        activeName2: '0',
        showEditFailInfo: false, //修改失败人员信息
        bankList: [], //发薪子公司银行账户列表
        payForm: {
          payAccount: [],
          id: '',
          ids: '',
          MainId: '',
        },
        legList: [], //主体列表
        PayrollSum: 0, //打款总金额
        successData: [],
        isBtnLoading: false, //按钮加载状态
        type: '',
        BankAccount: [], //商务主体银行账户
        showInnerPay: false, //内部转账弹窗
        allAccount: [], //垫支账户列表
        dzAcc: '',
        dzCompany: '',
        dzOpenBank: '',
        ApplyDepositAccount: '', //垫支账户
        MainpayAccount: '', //
        payAccount2: [],
        headPath: this.$store.state.EMP.tablePath,
        docHeadPath: this.$store.state.EMP.docPath,
        showSysTips: false,
        sysQuery: {
          id: '',
          PageNumber: 1,
          PageSize: 10
        },
        showBSTips: false,
        showLWtips: false,
        sysLoading: false,
        sysTotal: 0,
        sysTipsData: [],
        countdown: 0,
        timer: null,
        VerifCode: '',
        JXJList: [], //杰小金账户列表
      }
    },
    created() {
      if (this.$route.query.Id != undefined && this.$route.query.Id) {
        this.listQuery.id = this.$route.query.Id;
        this.payForm.MainId = this.$route.query.Id;
        this.getApplicationPayrollDetail();
        this.getAllLegalAccount();
        this.getlegalsubjectlist();
      }
    },
    methods: {
      checkPermission,
      getApplicationPayrollDetail() {
        xz.getApplicationPayrollDetail(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.baseInfo = res.data.data;
            this.tableData = res.data.ApproveringList;
            this.totalCount = res.data.totalcount;
            if (res.data.data.PayrollChannel == '报销款（不报税）') {
              this.showBSTips = true;
            }
            if (res.data.data.IncomeTaxType == '劳务报酬') {
              this.showLWtips = true;
            }
            this.getCompfinanceSet();
            this.GetRiskAlertResultById();
          } else {
            this.$message.error('获取详情出错')
            this.baseInfo = {};
            this.tableData = []
          }
        })
      },
      GetRiskAlertResultById() {
        this.sysQuery.id = this.listQuery.id;
        this.sysQuery.PageNumber = 1;
        xz.AdvanceFun(this.sysQuery, 'GetRiskAlertListById').then(res => {
          try {
            if (res.status == 'ok') {
              if (res.data.retList.length > 0) {
                this.sysTipsData = res.data.retList;
                this.sysTotal = res.data.totalCount;
                this.showSysTips = true;
              }
            } else {
              this.$message.error(res.msg);
            }
          } catch (e) {
            console.log(e)
            this.$message.error('系统出错')
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getApplicationPayrollDetail();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getApplicationPayrollDetail();
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      down(url, head) {
        var path = head + url;
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      //确认新增/修改
      confirmSubmit() {
        this.$refs["salaryForm"].validate((valid) => {
          if (valid) {}
        })
      },
      viewDtl(row) {
        this.$router.push({
          path: '/salaryDtl',
          query: {
            type: row.type
          }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // //判断是否可以勾选
      // selectEnable(row) {
      //   if (row.ProcessState != '待发薪') {
      //     return false
      //   } else {
      //     return true
      //   }
      // },
      clear() {
        this.payForm = {
          payAccount: [],
          id: '',
          ids: '',
          MainId: this.$route.query.Id,
        }
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          Id: this.listQuery.id,
          ProcessState: '待发薪'
        }
        xz.getPayrollCompanyList(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data;
          } else {
            this.legList = [];
          }
        })
      },
      //cbs打款
      cbsPayment() {
        this.type = 'cbs';
        this.clear();
        // if (this.baseInfo.ApplyDeposit > 0 && !this.ApplyDepositAccount) {
        //   this.$message.warning('请先选择垫支公司/银行账号')
        // } else {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          let canPay = true;
          try {
            this.multipleSelection.forEach(element => {
              if (element.ProcessState != '待发薪') {
                this.$message.warning(element.ProcessState + '状态下的员工不能打款');
                canPay = false;
                throw Error('termination')
              } else {
                arr.push(element.Id)
              }
            });
          } catch (e) {}
          if (canPay) {
            this.payForm.ids = arr.toString();
            let data = {
              id: this.listQuery.id,
              ids: arr.toString()
            }
            this.successData = this.multipleSelection;
            xz.selectPayrollBankAccount(data, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.bankList = res.data.RetList;
                this.bankList.forEach(element => {
                  this.$set(element, 'payAccount', '');
                  this.$set(element, 'payOpenBnak', '');
                  this.$set(element, 'RpaAccount', '0'); //CBS银行账户 / 杰小金账户
                  element.AccountList.forEach(e => {
                    if (e.IsDefault != undefined && e.IsDefault == '1') {
                      this.$set(element, 'payAccount', e.Account);
                      this.$set(element, 'payOpenBnak', e.OpeningBank);
                    }
                  });
                });
                this.PayrollSum = res.data.PayrollSum;
                this.innerVisibleCA = true;
                console.log(this.bankList)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg,
                  duration: 5000
                })
              }
            })
          }
        } else {
          this.$message.warning('请至少选择一位员工')
        }
        // }

      },
      cbsAllPayment() {

        this.type = 'all';
        this.clear();
        let data = {
          id: this.listQuery.id,
          ids: ''
        }
        this.successData = this.multipleSelection;
        xz.selectPayrollBankAccount(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.bankList = res.data.RetList;
            this.bankList.forEach(element => {
              this.$set(element, 'payAccount', '');
              this.$set(element, 'payOpenBnak', '');
              element.AccountList.forEach(e => {
                if (e.IsDefault != undefined && e.IsDefault == '1') {
                  this.$set(element, 'payAccount', e.Account);
                  this.$set(element, 'payOpenBnak', e.OpeningBank);
                }
              });
            });
            this.PayrollSum = res.data.PayrollSum;
            this.innerVisibleCA = true;
          } else {
            this.$message({
              type: 'error',
              message: res.msg,
              duration: 5000
            })
          }
        })
      },
      beforePay() {
        // if (this.dzAcc || this.baseInfo.PayrollCompany != this.baseInfo.Subject) {
        let arr = [];
        let arr2 = [];
        this.bankList.forEach((element, index) => {
          if (element.payAccount) {
            let data = {
              CompanyName: element.CompanyName,
              Account: element.payAccount,
              RpaAccount: element.RpaAccount
            }
            arr.push(data)
            let data2 = {
              CompanyName: element.CompanyName,
              Account: element.payAccount,
              OpeningBank: element.OpeningBank,
              CompanyPayrollSum: element.CompanyPayrollSum,
              payOpenBnak: element.payOpenBnak
            }
            arr2.push(data2)
          }
          if (index == this.bankList.length - 1) {
            this.payForm.payAccount = arr;
            this.payAccount2 = arr2;
            // console.log('cc',this.payAccount2)
            if (this.type == 'all') {
              this.payForm.id = this.listQuery.id;
              this.payForm.ids = '';
            } else if (this.type == 'cbs') {
              this.payForm.id = '';
            }
            if (this.payForm.payAccount.length > 0) {
              this.innerVisibleCA = false;
              this.showInnerPay = true;
            } else {
              this.$message.warning('请选择发薪子公司银行账户')
            }
          }
        });
        // } else {
        //   let arr = [];
        //   this.bankList.forEach((element, index) => {
        //     if (element.payAccount) {
        //       let data = {
        //         CompanyName: element.CompanyName,
        //         Account: element.payAccount
        //       }
        //       arr.push(data)
        //     }
        //     if (index == this.bankList.length - 1) {
        //       this.payForm.payAccount = arr;
        //       if (this.type == 'all') {
        //         this.payForm.id = this.listQuery.id;
        //         this.payForm.ids = '';
        //       } else if (this.type == 'cbs') {
        //         this.payForm.id = '';
        //       }
        //       this.confirmPay();
        //     }
        //   });
        //   // console.log('confirmPay')
        // }
      },
      //确认打款
      confirmPay() {
        this.isBtnLoading = true;
        // console.log(this.payForm)
        xz.cbsRemit(this.payForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getApplicationPayrollDetail();
            this.isBtnLoading = false;
            this.innerVisibleCA = false;
            this.innerVisibleRes = true;
          } else {
            this.isBtnLoading = false;
            this.$message({
              type: 'error',
              message: res.msg,
              duration: 8000
            })
          }
        })
      },
      confirmInnerPay() {
        if (!this.MainpayAccount) {
          this.$message.warning('请选择付款账号')
        } else {
          this.isBtnLoading = true;
          let data = {
            payAccount: this.payForm.payAccount,
            id: this.payForm.id,
            ids: this.payForm.ids,
            MainId: this.payForm.MainId,
            MainpayAccount: this.MainpayAccount,
            ApplyDepositAccount: this.ApplyDepositAccount
          }
          xz.cbsRemit(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.getApplicationPayrollDetail();
              this.isBtnLoading = false;
              this.innerVisibleCA = false;
              this.showInnerPay = false;
              this.innerVisibleRes = true;
            } else {
              this.isBtnLoading = false;
              this.showInnerPay = false;
              this.$message({
                type: 'error',
                message: res.msg,
                duration: 8000
              })
            }
          })
          // console.log(data)
        }
      },
      //手工登记成功/失败
      handel(type) {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach(element => {
            arr.push(element.Id)
          });
          let data = {
            MainId: this.listQuery.id,
            ids: arr.toString()
          }
          if (type == 'success') {
            xz.registerRemitSuccess(data, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('操作成功')
                this.getApplicationPayrollDetail();
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg,
                  duration: 5000
                })
              }
            })
          } else {
            xz.registerRemitFail(data, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('操作成功')
                this.getApplicationPayrollDetail();
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg,
                  duration: 5000
                })
              }
            })
          }
        } else {
          this.$message.warning('请至少选择一位员工')
        }
      },
      //获取主体银行账户
      getCompfinanceSet() {
        xz.getCompfinanceSet(this.baseInfo.Subject, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (!res.data.BankAccountJ) {
              this.BankAccount = []
            } else {
              res.data.BankAccountJ.forEach(element => {
                if (element.IsDefault != undefined && element.IsDefault == '1') {
                  this.MainpayAccount = element.Account
                }
              });
              this.BankAccount = res.data.BankAccountJ;
            }
          } else {
            this.BankAccount = [];
          }
        })
      },
      //获取垫支账户列表
      getAllLegalAccount() {
        xz.getAllLegalAccount('').then(res => {
          if (res.status == 'ok') {
            this.allAccount = res.data;
          } else {
            this.allAccount = [];
          }
        })
      },
      changeDz(val) {
        this.ApplyDepositAccount = val.Account;
        this.dzOpenBank = val.OpeningBank;
        this.dzCompany = val.CompanyName;
      },
      inputChange(val, item, payOpenBnak) {
        this.$set(item, 'payOpenBnak', payOpenBnak)
      },
      exportList() {
        let data = {
          ParentId: this.listQuery.id,
          Type: '5'
        }
        this.loading = true;
        xz.payrollApplicationExport(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = this.baseInfo.ProjectName + '-待发薪人员列表.xls' //这里写保存时的名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error(res.msg)
          }
        })
      },
      cancel() {
        this.$router.go(-1)
      },
      sendSms() {
        xz.SendPayRiskVerifCode(this.listQuery.id, Cookies.get("userid-b")).then(res => {
          if (res.status == 'ok') {
            this.$message.success('验证码发送成功')
            this.timecount()
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      timecount() {
        const TIME_COUNT = 60; //倒计时60秒
        if (!this.timer) {
          this.countdown = TIME_COUNT;
          this.isDisabled = true;
          this.timer = setInterval(() => {
            if (this.countdown > 0 && this.countdown <= TIME_COUNT) {
              this.countdown--;
            } else {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      },
      checkSms() {
        if (this.VerifCode) {
          xz.CheckPayRiskVerifCode(this.listQuery.id, Cookies.get("userid-b"), this.VerifCode).then(res => {
            if (res.status == 'ok') {
              this.$message.success('该笔发薪已解除系统风控');
              this.showSysTips = false;
              this.showSysSms = false;
            } else {
              this.$message.error(res.msg);
              this.showSysTips = false;
              this.showSysSms = false;
            }
          })
        }
      },
      goback() {
        this.$router.push({
          path: '/payment',
          query: {
            activeName: '待发薪'
          }
        })
      },
      changePayType(val, item) {
        this.$set(item, 'payAccount', '')
        if (val == 1) {
          let str = `?AccountName=${item.CompanyName}`;
          xz.ArdCurStatGetFun('GeProductName', str).then(res => {
            if (res.status == 'ok') {
              this.$set(item, 'JXJList', this.capitalizeKeys(res.data))
            } else {
              this.JXJList = [];
            }
          })
        }
      },
      //首字母转大写
      capitalizeKeys(obj) {
        if (typeof obj !== 'object' || obj === null) return obj;
        if (Array.isArray(obj)) {
          return obj.map(item => this.capitalizeKeys(item));
        }
        const capitalizedObj = {};
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            // 将属性名首字母转大写
            const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
            capitalizedObj[capitalizedKey] = obj[key];
          }
        }
        return capitalizedObj;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .basicInfo {
    flex-wrap: wrap;
    margin-bottom: 15px;
    padding-top: 20px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    min-width: 150px;
    margin-right: 15px;
    line-height: 32px;
    margin-right: 20px;
  }

  .salaryPayingCompanyItem {
    margin-bottom: 30px;
  }

  .salaryPayingCompany {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  .salaryPayingCompany_radio {
    padding-left: 30px;
  }

  .payResult {
    margin-bottom: 20px;
  }

  .payAmount {
    margin-left: 30px;
  }

  .formItem {
    width: 300px
  }

  .down {
    color: #409EFF;
    margin-right: 15px;
  }

  .noAccountTips {
    font-size: 14px;
  }

  .payTips2 {
    color: red;
    font-size: 16px;
  }
</style>
<style>
  .page_paymentDtl .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_paymentDtl .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_paymentDtl .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_paymentDtl .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_paymentDtl .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_paymentDtl .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>